import { IUserLiveInfo } from "services/apis/types";
import { cookies } from "./universal-cookie";

const KEY = "live-info";

export function setToCookie(info: IUserLiveInfo) {
  cookies.set(KEY, info);
}

export function getFromCookie(): IUserLiveInfo | undefined {
  return cookies.get<IUserLiveInfo>(KEY);
}
